module.exports = __webpack_public_path__ + "img/thank_you_page.aeb4c36b.jpg";